import React, { useEffect, useState } from "react"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"

import { useLocation, useNavigate } from "react-router-dom"
import { X } from "react-feather"
import clsx from "clsx"

import Button from "../../components/button"
import Label from "../../components/label"
import dayjs from "../../plugins/dayjs"
import { isEmpty } from "../../helpers/object"
import API from "../../api"

import BrandIndex from "../../pages/settings/brand"
import BrandAlarm from "../../pages/settings/alarm"
import BrandPassword from "../../pages/settings/password"
import BRAND from "../../constants/brand"
import { useLanguage } from "@languages/index"

function calculateTimeLeft(regDt) {
  const targetDate = dayjs(regDt)
  const now = dayjs()

  let timeLeft = {}

  if (targetDate.isAfter(now)) {
    timeLeft = {
      days: targetDate.diff(now, "day"),
      hours: (targetDate.diff(now, "hour") % 24).toString().padStart(2, "0"),
      minutes: (targetDate.diff(now, "minute") % 60).toString().padStart(2, "0"),
      seconds: (targetDate.diff(now, "second") % 60).toString().padStart(2, "0"),
      ms: (targetDate.diff(now, "millisecond") % 100).toString().padStart(2, "0"),
    }
  }

  return timeLeft
}

const MissionsIndex = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.help }
  const navigate = useNavigate()
  const location: any = useLocation()
  const isWholesale = props.brand.businessType === BRAND.BUSINESS_TYPE.WHOLESALE

  const missions = [
    {
      hidden: isWholesale,
      page: BrandIndex,
      title: languageTexts.missions_1_title,
      estimatedTime: languageTexts.missions_1_est,
      description: languageTexts.missions_1_desc(props.brand.categoryId),
      //   url: "/settings/brand",
      isCompleted: !isEmpty(props.brand) && props.brand.hasExperiencedInfoUpdate,
    },
    {
      hidden: false,
      page: BrandAlarm,
      title: languageTexts.missions_2_title,
      estimatedTime: languageTexts.missions_2_est,
      description: languageTexts.missions_2_desc(props.brand.categoryId),
      //   url: "/settings/brand/alarm",
      isCompleted: !isEmpty(props.brand) && props.brand.hasExperiencedAlarmUpdate,
    },
    {
      hidden: false,
      page: BrandPassword,
      title: languageTexts.missions_3_title,
      estimatedTime: languageTexts.missions_3_est,
      description: languageTexts.missions_3_desc,
      //   url: "/settings/brand/password",
      isCompleted: !isEmpty(props.brand) && props.brand.hasExperiencedPasswordUpdate,
    },
  ]

  const [timeLeft, setTimeLeft] = React.useState(
    calculateTimeLeft(dayjs(props.brand.regDt).add(2, "day").format("YYYY-MM-DD"))
  )

  useEffect(() => {
    const id = setTimeout(() => {
      if (props.brand.isSeedingPassWelcomeBonusEnabled == true && props.brand.hasExperiencedSeedingPass == false) {
        setTimeLeft(calculateTimeLeft(dayjs(props.brand.regDt).add(2, "day").format("YYYY-MM-DD")))
      } else {
        clearTimeout(id)
      }
    }, 10)

    if (props.brand.isSeedingPassWelcomeBonusEnabled == false || props.brand.hasExperiencedSeedingPass == true) {
      clearTimeout(id)
    }

    return () => {
      clearTimeout(id)
    }
  }, [timeLeft])

  useEffect(() => {
    fetchBrand()
  }, [])

  const fetchBrand = () => {
    API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        props.setBrand(response.data.brand)
      })
      .catch((error) => {
        console.log(error)
        props.showModal({
          text: languageTexts.missions_text_1,
        })
      })
  }

  const TimerComponents = () => {
    if (!timeLeft) {
      return <></>
    }

    return (
      <span className="text-[#000000] font-bold text-[2.25rem] tracking-tighter">
        {`${languageTexts._day(timeLeft["days"])} ${timeLeft["hours"]}:${timeLeft["minutes"]}:${timeLeft["seconds"]}:${
          timeLeft["ms"]
        }`}
      </span>
    )
  }

  const renderWelcomeMessage = () => {
    return (
      <div className="page-title flex flex-col py-7 md:py-[3.75rem]">
        <span className="font-bold text-2xl md:text-[2.25rem] leading-normal tracking-tighter">
          {languageTexts._missions_text_3()}
        </span>
      </div>
    )
  }

  const renderMissionItem = (mission, index) => {
    return (
      <div
        key={index}
        className={clsx({
          "flex flex-col border border-[#E8E8E8] rounded-[0.625rem] p-5 md:px-[1.875rem] md:py-[1.75rem] gap-2": true,
        })}
      >
        <div className="flex flex-row justify-between">
          <div className="flex flex-col gap-[0.9375rem]">
            <div className="flex flex-row gap-3 items-center">
              <div>
                <span className="font-bold text-base md:text-xl tracking-tighter">
                  {index + 1 + ". " + mission.title}
                </span>
              </div>
              <div>
                <Label
                  className="px-2 py-1 text-sm"
                  labelColor="rgb(93, 95, 239, 0.1)"
                  textColor="#000000"
                  text={mission.estimatedTime}
                />
              </div>
            </div>
            <div className="flex flex-row items-center">
              <span className="text-[#999999] text-[0.9375rem] leading-normal tracking-tighter pr-2">
                {mission.description}
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <div>
              <Button
                className={
                  "min-w-[80px] md:min-w-[10rem] h-[3rem] flex justify-center items-center text-center px-3"
                }
                borderColor={mission.isCompleted ? "#E8E8E8" : "#000000"}
                buttonColor={mission.isCompleted ? "white" : "#000000"}
                textClassName={"text-[0.9375rem] font-bold tracking-tighter"}
                textColor={mission.isCompleted ? "#000000" : "white"}
                text={mission.isCompleted ? languageTexts.missions_text_4 : languageTexts.missions_text_5}
                onClick={() => {
                  if (mission.url) {
                    navigate(mission.url)
                    return false
                  }

                  if (mission.page) {
                    let containerStyle = "flex flex-col w-full px-5 pt-5 pb-8 bg-white overflow-scroll max-w-[480px]"

                    if (props.preferences.isMobile) {
                      containerStyle = `${containerStyle} h-full`
                    } else {
                      containerStyle = `${containerStyle} rounded-2xl`
                    }

                    props.showOverlays({
                      className: containerStyle,
                      content: () => {
                        return (
                          <div className="relative flex flex-col">
                            <div
                              className="cursor-pointer absolute top-1 right-1"
                              onClick={() => {
                                props.closeOverlays()
                              }}
                            >
                              <X strokeWidth={1} className="cursor-pointer" />
                            </div>
                            <mission.page
                              onUpdate={() => {
                                fetchBrand()
                                props.closeOverlays()
                              }}
                            />
                          </div>
                        )
                      },
                    })
                  }
                }}
              />
            </div>
          </div>
        </div>

        {props.brand.isSeedingPassWelcomeBonusEnabled == true &&
        mission.isApplicable == true &&
        mission.hasExperienced == false &&
        dayjs(props.brand.regDt).isAfter("2023-06-04") ? (
          <div className="flex flex-col gap-[0.8125rem] border border-[#000000] rounded-[0.625rem] px-[1.875rem] py-[1.625rem] mt-[1.125rem]">
            <div className="flex flex-row gap-2">
              <img className="w-5 h-5" src="/assets/icons/ic-gift.svg" />
              <span className="text-[#000000] font-bold text-[0.9375rem] tracking-tighter">
                {languageTexts.missions_text_6}
              </span>
            </div>

            <div>
              <span>
                {isEmpty(timeLeft) == false ? (
                  <div className="flex flex-row">
                    <div className="w-[262px]">
                      <TimerComponents />
                    </div>

                    <span className="text-[#000000] font-bold text-[2.25rem] tracking-tighter">
                      {languageTexts.missions_text_7}
                    </span>
                  </div>
                ) : (
                  <span>{languageTexts.missions_text_8}</span>
                )}
              </span>
            </div>

            <div>
              <span className="text-[#000000] font-bold text-[0.9375rem] tracking-tighter">
                {languageTexts._missions_text_9()}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    )
  }

  const renderMissionList = () => {
    return (
      <div className="flex flex-col gap-[15px]">
        {missions
          .filter((mission) => !mission.hidden)
          .map((mission, index) => {
            return renderMissionItem(mission, index)
          })}
      </div>
    )
  }

  return (
    <>
      <div className="px-7 pb-60 mx-auto flex flex-col max-w-[60rem]">
        {renderWelcomeMessage()}
        {renderMissionList()}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(MissionsIndex)
